import { orderBy } from 'lodash-es';
import { isFunction } from './validators';
export function sortObjects(items, sort) {
  var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['asc'];
  if (!items || !sort) return items;
  var sortArray = Array.isArray(sort) ? sort : [sort];
  var iteratees = sortArray.map(function (iteratee) {
    if (isFunction(iteratee)) return iteratee;
    return function (item) {
      var value = item[iteratee];
      if (typeof value === 'string') return value.toLowerCase();
      return value;
    };
  });
  return orderBy(items, iteratees, order);
}